import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  contentContainer: {
    '@media (max-width: 768px)': {
      paddingTop: '85px',
    },
  },
  fieldParent: {
    marginBottom: '38px',
    '@media (max-width: 768px)': {
      marginBottom: '24px',
    },
  },
  buttonParent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '52px',
    '@media (max-width: 768px)': {
      justifyContent: 'center',
      marginTop: '24px',
    },
  },
  button: {
    minWidth: '182px !important',
    '@media (max-width: 768px)': {
      width: '100%',
    },
  },
  projectName: {
    fontSize: '20px',
    lineHeight: '26px',
    fontWeight: 500,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    marginTop: '-30px',
  },
  tabsParent: {
    marginTop: '52px',
    marginBottom: '52px',
    '@media (max-width: 768px)': {
      marginTop: '24px',
      marginBottom: '24px',
    },
  },
  companySelectionModal: {
    '& .MuiDialog-paper': {
      width: '500px',
      maxWidth: '100%',
    },
  },
  companySelectionModalButton: {
    width: '100% !important',
  },
  companyAdminsWarning: {
    marginBottom: '28px',
  },
  companyAdminLink: {
    color: STYLE.COLOR.ACCENT_PRIMARY,
    textDecoration: 'underline',
    fontWeight: 600,
  },
  buildInfo: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT3,
    marginTop: '16px',
    textAlign: 'center',
  },
}));
